import i18next from "i18next";
import { Trans } from "react-i18next";
import React from "react";

import { Callout, Pre, Tag } from "@blueprintjs/core";

import { TableCustom } from "../../Structure/navbar/blueprintTableincludes";
import ServerSelect from "../../Structure/ServerSelector";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";

export default class FileSync extends React.Component {
  constructor() {
    super();
    this.state = {
      server: undefined,
      db: undefined,
      version: undefined,
    };
  }

  componentDidMount() {
    authenticatedGetFetch("/db", (db) => this.setState({ db: db }));
  }

  render() {
    return (
      <>
        <Callout title={<Trans>history file sync</Trans>} icon="data-sync">
          <ServerSelect
            onSelect={(id, srv) => this.setState({ server: srv })}
          />
          <TableCustom
            paging={true}
            url={"/maintenance/files?srv=" + this.state?.server?.id}
            orderBy="fileName"
            columns={[
              {
                title: <Trans>fileName</Trans>,
                field: "fileName",
                sortable: false,
                render: (raw) => raw.fileName,
              },
              {
                title: <Trans>last modification date</Trans>,
                field: "LASTMODIFICATION",
                sortable: false,
                render: (raw) => {
                  if (raw?.LASTMODIFICATION)
                    return new Date(raw.LASTMODIFICATION).toLocaleString(
                      i18next.language
                    );
                  else return "";
                },
              },
              {
                title: <Trans>synchronization</Trans>,
                field: "FULLY_SYNCHRONIZED",
                sortable: false,
                render: (raw) => {
                  // TODO: add not other files not registered yes
                  if (raw.toResync)
                    return (
                      <Tag intent="danger">
                        <Trans>pending</Trans>
                      </Tag>
                    );
                  if (!raw.FULLY_SYNCHRONIZED && !raw.LASTMODIFICATION)
                    return (
                      <Tag intent="danger">
                        <Trans>pending</Trans>
                      </Tag>
                    );
                  return raw.FULLY_SYNCHRONIZED ? (
                    <Tag intent="success">
                      <Trans>synchronized</Trans>
                    </Tag>
                  ) : (
                    <Tag intent="warning">
                      <Trans>in progress</Trans>
                    </Tag>
                  );
                },
              },
              {
                title: <Trans>server</Trans>,
                field: "serverId",
                sortable: false,
                render: (raw) => raw?.server?.name,
              },
            ]}
          />
        </Callout>
        <br />
        {this.state.db && (
          <Callout title={<Trans>database</Trans>}>
            <Pre>database size: {JSON.stringify(this.state.db)}</Pre>
          </Callout>
        )}
      </>
    );
  }
}
